import { workPsnlworkProxy } from './index';
// proxy/work/psnlwork/

/* [ 일정 ] */
// 개인별일정 목록조회
function getPsnlCalendarMonList(params) {
  return workPsnlworkProxy.get('calendar/month/list', { params });
}
// 부서별일정 목록조회
function getOrgGntWorkStaPsnlCalendarMonList(params) {
  return workPsnlworkProxy.get('calendar/org/orggntworksta/list', { params });
}

// 공휴일 목록조회
function getOrgHolidayList(params) {
  return workPsnlworkProxy.get('calendar/org/holiday/list', { params });
}

// 휴일 근무일자 선택 가능일 조회
function getHolReplaceCalendarMonList(params) {
  return workPsnlworkProxy.get('calendar/hol/replace/month/list', { params });
}

// 평일 대체 근무일자 선택 가능일 조회
function getHolReplaceCalendarPeriodMonList(params) {
  return workPsnlworkProxy.get('calendar/hol/replace/month/period', {
    params,
  });
}

export {
  getPsnlCalendarMonList,
  getOrgGntWorkStaPsnlCalendarMonList,
  getHolReplaceCalendarMonList,
  getHolReplaceCalendarPeriodMonList,
  getOrgHolidayList,
};
